import React, {Component} from 'react';
import {FormContentMainStyled, FormContentSizeMainStyled} from "../styled";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import PropTypes from 'prop-types';


class CreateFormMensageriaComponent extends Component {
    static ROUTE = '/mensageria-criar';

    render() {
        return (
            <FormContentMainStyled>
                <FormContentSizeMainStyled>
                    <TextFieldDefault label={'Assunto *'}
                                      name={'subject'}
                                      type={'text'}
                                      value={this.props.form?.subject || ''}
                                      onChange={(event) => this.props.onChangeForm && this.props.onChangeForm(event)}
                                      erros={this.props.erros}
                    />
                    <SpacerComponent height={8}/>
                    <TextFieldDefault label={'Mensagem *'}
                                      name={'body'}
                                      type={'text'}
                                      value={this.props.form?.body || ''}
                                      onChange={(event) => this.props.onChangeForm && this.props.onChangeForm(event)}
                                      erros={this.props.erros}
                                      multiline={true}
                                      rows={6}
                    />
                </FormContentSizeMainStyled>
            </FormContentMainStyled>
        );
    }
}

CreateFormMensageriaComponent.propTypes = {
    form: PropTypes.object,
    onChangeForm: PropTypes.func,
    erros: PropTypes.object,
};

CreateFormMensageriaComponent.defaultProps = {
    form: {
        subject: '',
        body: '',
    },
    onChangeForm: () => {},
    erros: {},
};

export default CreateFormMensageriaComponent;